export const SearchTypeEnum = Object.freeze({
  Products: 0,
  Bibles: 1
})
